import { useEffect } from "react";
import { getCookie } from "@maven-rest/states";

export interface RetrieveCookieRequestMessage {
  type: "RETRIEVE_COOKIE";
  name: string;
}

export interface RetrieveCookieResponseMessage {
  type: "RETRIEVED_COOKIE";
  name: string;
  value: string;
}

export const BRIDGE_IFRAME_ID = "bridge-iframe";

export function Bridge() {
  useEffect(() => {
    const handleMessage = (event: MessageEvent) => {
      if (!event.origin.split("//")[1].split(":")[0].endsWith("mavenclinical.com")) return;
      if ((event?.data as RetrieveCookieRequestMessage)?.type === "RETRIEVE_COOKIE") {
        const data = event.data as RetrieveCookieRequestMessage;
        const name = data.name;
        const value = getCookie(name);

        if (value) {
          const payload: RetrieveCookieResponseMessage = { type: "RETRIEVED_COOKIE", name, value };
          window.parent.postMessage(payload, event.origin);
        }
      }
    };

    window.addEventListener("message", handleMessage);

    return () => {
      window.removeEventListener("message", handleMessage);
    };
  }, []);

  return <>&nbsp;</>;
}

export function BridgeFrame() {
  const bridgeUrl = process.env.REACT_APP_SERVICE_SSO_FE_BRIDGE_URL;

  if (!bridgeUrl) return null;

  return (
    <iframe id={BRIDGE_IFRAME_ID} title="Bridge" src={bridgeUrl} style={{ display: "none" }} sandbox="allow-same-origin allow-scripts" />
  );
}
